import React, { useState } from "react";
import {
  Button,
  TextField,
  Snackbar,
  Alert,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import { Commute, Label, RestartAlt, Save } from "@mui/icons-material";
import axios from "axios";
import { create_travel_types_admin } from "../api/API";
import { AdminPage, SectionTitle, GREEN, primaryButtonSx } from "../admin/AdminPageLayout";

function MainAddFormOfTravel() {
  const [name, setName] = useState("");
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [loading, setLoading] = useState(false);
  const handleClose = () => setSnack((s) => ({ ...s, open: false }));
  const token = localStorage.getItem("token");

  const handleReset = () => {
    setName("");
    console.log("Form reset.");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      return setSnack({
        open: true,
        message: "กรุณากรอกชื่อประเภทการเดินทาง",
        severity: "error",
      });
    }
    setLoading(true);

    try {
      const res = await axios.post(
        create_travel_types_admin,
        { name }, // ← send { name: "..." }
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 201) {
        setSnack({ open: true, message: "บันทึกสำเร็จ", severity: "success" });
        setName("");
      } else {
        setSnack({
          open: true,
          message: "บันทึกไม่สำเร็จ: " + res.statusText,
          severity: "error",
        });
      }
    } catch (err) {
      console.error(err);
      setSnack({
        open: true,
        message: "เกิดข้อผิดพลาดระหว่างเชื่อมต่อ",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AdminPage
        maxWidth={640}
        icon={<Commute fontSize="large" />}
        title="เพิ่มรูปแบบ"
        subtitle="เพิ่มประเภทรูปแบบการเดินทางใหม่เข้าสู่ระบบ"
        actions={
          <>
            <Button
              variant="outlined"
              color="warning"
              size="large"
              startIcon={<RestartAlt />}
              onClick={handleReset}
              sx={{ borderRadius: 3, width: { xs: "100%", sm: "auto" } }}
            >
              รีเซตค่า
            </Button>
            <Button
              variant="contained"
              size="large"
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Save />}
              onClick={handleSubmit}
              sx={primaryButtonSx}
            >
              {loading ? "กำลังบันทึก..." : "ยืนยันการเพิ่ม"}
            </Button>
          </>
        }
      >
        <SectionTitle step={1} title="ชื่อรูปแบบ" />
        <TextField
          fullWidth
          label="ชื่อ"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="กรอกชื่อรูปแบบ"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Label sx={{ color: GREEN }} />
              </InputAdornment>
            ),
          }}
        />
      </AdminPage>
      <Snackbar
        open={snack.open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleClose}
          severity={snack.severity}
          sx={{ width: "100%" }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default MainAddFormOfTravel;
